export default "/_next/static/a152ba9b069a4f42034716ff8b818a30.png";